import { useState } from "react";
import { useRef } from "react";
import { Upload, Loader2, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Card, Field, TextInput, TextArea, SaveButton } from "./kit";

export function AboutEditor({ initial, onSave, saving }) {
  const [d, setD] = useState(null);
  const [uploading, setUploading] = useState(-1);
  const fileRef = useRef(null);
  if (!initial) return null;
  const value = d || initial;

  const upload = async (index, file) => {
    setUploading(index);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/admin/upload", fd);
      const images = [...(value.images || [])];
      while (images.length < 2) images.push("");
      images[index] = data.url;
      setD({ ...value, images });
      toast.success("Image uploaded — press Save & Go Live");
    } catch (e) {
      toast.error("Upload failed");
    } finally {
      setUploading(-1);
    }
  };

  return (
    <Card title="About Us Editor" desc="Update the public About Us page — changes reflect live immediately.">
      <Field label="Headline">
        <TextInput value={value.headline || ""} onChange={(e) => setD({ ...value, headline: e.target.value })} />
      </Field>
      <Field label="Story text">
        <TextArea rows={7} value={value.story || ""} onChange={(e) => setD({ ...value, story: e.target.value })} />
      </Field>
      <Field label="Team description">
        <TextArea rows={4} value={value.team_description || ""} onChange={(e) => setD({ ...value, team_description: e.target.value })} />
      </Field>
      <Field label="Images (two slots shown on the page)">
        <div className="grid grid-cols-2 gap-4">
          {[0, 1].map((i) => (
            <div key={i} className="rounded-xl border border-white/10 bg-[#0A0F2C]/40 p-3">
              {value.images?.[i] ? (
                <img src={value.images[i]} alt="" className="w-full h-28 object-cover rounded-lg mb-3" />
              ) : (
                <div className="w-full h-28 rounded-lg bg-white/5 mb-3 flex items-center justify-center text-slate-500 text-xs">Empty slot</div>
              )}
              <div className="flex gap-2">
                <button
                  className="btn btn-sm btn-outline-light flex-1"
                  onClick={() => fileRef.current?.click()}
                  data-testid={`about-upload-${i}`}
                >
                  {uploading === i ? <Loader2 size={13} className="animate-spin" /> : <Upload size={13} />} Upload
                </button>
                {value.images?.[i] && (
                  <button
                    className="p-2 text-slate-500 hover:text-red-400 transition-colors"
                    onClick={() => { const images = [...(value.images || [])]; images[i] = ""; setD({ ...value, images }); }}
                    aria-label="Remove image"
                  >
                    <Trash2 size={14} />
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
        <input
          ref={fileRef}
          type="file"
          accept="image/*"
          className="hidden"
          onChange={(e) => e.target.files?.[0] && upload(uploading < 0 ? 0 : uploading, e.target.files[0])}
        />
      </Field>
      <SaveButton onClick={() => onSave("about", value)} saving={saving} />
    </Card>
  );
}
